import * as React from "react";
import {CardTitle, Chip} from 'material-ui';

const styles = {
    chip: {
        margin: '0.1em',
        backgroundColor: '#eedcc6'
    },
    wrapper: {
        display: 'flex',
        margin: '0.5em'
    },
    iconChip: {
        verticalAlign: 'middle',
        margin: '0.1em',
        fontSize: '1.2em',
        color: '#d15844',
    },
    iconGlyph: {
        verticalAlign: 'middle',
        margin: '0.1em',
        fontSize: '1.2em',
        color: '#d15844',
        paddingBottom: '0.9em'
    },
};

const instrumentDecoder = code => {

    const iconsClassName = [
        'songtive-icon-drums',
        'songtive-icon-aguitar',
        'songtive-icon-violin',
        'songtive-icon-sax',
        'songtive-icon-flute',
        'songtive-icon-eguitar',
        'songtive-icon-bass',
        'glyphicons piano',
        'glyphicons microphone'];

    const result = [];
    for (let i = 0; i < iconsClassName.length; ++i) {
        if ((code & (1 << i)) !== 0) {
            result.push(iconsClassName[i]);
        }
    }

    return result;
};


const Instruments = ({encodedInstruments}) => {

    const instruments = instrumentDecoder(encodedInstruments);

    const icons = instruments.map(eachClass => {
        if (eachClass.includes('glyphicons')) {
            return <span key={eachClass} className={eachClass} style={styles.iconGlyph}/>
        } else {
            return <span key={eachClass} className={eachClass} style={styles.iconChip}/>
        }

    });

    return (
        <div style={styles.wrapper}>
            <Chip style={styles.chip}>
                {icons}
            </Chip>
        </div>
    );

};

const SongTags = ({type, tags}) => {

    const tagChips = tags.map(eachTag => {

        const href = `/feed/${type}/${eachTag.name}`;
        return (
            <Chip key={eachTag.name} style={styles.chip}>
                <a href={href}>#{eachTag.name}</a>
            </Chip>
        );
    });

    return (
        <div style={styles.wrapper}>
            {tagChips}
        </div>
    );
};

const Title = ({url, songName}) => {
    return <a href={url}>{songName}</a>;
};

interface ISongCardBodyProps
{
    songName: string,
    songDescription: string,
    songInstruments: number,
    songTags: Array<string>,
    songUrl: string,
    type: string
}

class SongCardBody extends React.Component<ISongCardBodyProps, any> {
    render() {
        const title = <Title songName={this.props.songName} url={this.props.songUrl}/>;
        const instruments = (this.props.type === 'songs') ? <Instruments encodedInstruments={this.props.songInstruments}/> : <div/>;
        return (
            <div>
                <CardTitle title={title} subtitle={this.props.songDescription}/>
                {instruments}
                <SongTags tags={this.props.songTags} type={this.props.type}/>
            </div>
        );

    }

}

export default SongCardBody;



// WEBPACK FOOTER //
// ./components/songs/SongCardBody.tsx